import readlangClient from "readlangClient";
import translateErrorHandler from "translateErrorHandler";
import * as transliterations from "transliterations";
import { contextTranslationUsageSignal } from "views/ContextTranslationStrip";
import * as walkthrough from "walkthrough";

export const getTranslator =
  (options) =>
  async (data, success, errorCallback, transliterationCallback) => {
    let responseData: any;

    try {
      responseData = (
        await readlangClient.request(
          "POST",
          "/api/translate",
          data,
          undefined,
          undefined
        )
      ).data;
    } catch (error) {
      // On a terminal failure (network loss, 5xx) readlangClient already
      // showed a notification bar, so skip the domain error handling.
      if (!error.jqXHR?.alreadyNotified) {
        translateErrorHandler(
          error.jqXHR,
          options.stores,
          options.notify,
          options.dismissNotification
        );
      }
      errorCallback();
      return;
    }

    success(responseData);
    walkthrough.setAchievement("translate", true);
    walkthrough.setAchievement("setLanguages", true);

    if (
      responseData.contextTranslationsRemaining !== undefined &&
      responseData.contextTranslationsLimit !== undefined
    ) {
      contextTranslationUsageSignal.value = {
        remaining: responseData.contextTranslationsRemaining,
        limit: responseData.contextTranslationsLimit,
      };
    }

    if (!(await transliterations.show(data.source))) {
      return;
    }

    // Get transliteration
    const transliteration = await transliterations.fetch(data.source, data.q);

    transliterationCallback(transliteration);
  };
